import { Sizes } from "../constants/size";
import type { IconProps } from "../types/icon-props";

export const InstagramColored = (props: IconProps) => {
  const {
    size = "md",
    fill = "var(--grey-1)",
    stroke = "var(--grey-1)",
    ...rest
  } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 33 32"
      fill="none"
      {...rest}
    >
      <g clipPath="url(#clip0_9796_197)">
        <path
          d="M22.717 0H9.78297C4.52647 0 0.25 4.27647 0.25 9.53297V22.467C0.25 27.7235 4.52647 32 9.78297 32H22.717C27.9735 32 32.25 27.7235 32.25 22.467V9.53297C32.2499 4.27647 27.9735 0 22.717 0ZM29.0308 22.467C29.0308 25.954 26.204 28.7808 22.717 28.7808H9.78297C6.296 28.7808 3.4692 25.954 3.4692 22.467V9.53297C3.4692 6.04594 6.296 3.2192 9.78297 3.2192H22.717C26.204 3.2192 29.0308 6.04594 29.0308 9.53297V22.467Z"
          fill="url(#paint0_linear_9796_197)"
        />
        <path
          d="M16.2509 7.72363C11.6874 7.72363 7.97461 11.4364 7.97461 15.9999C7.97461 20.5634 11.6874 24.2763 16.2509 24.2763C20.8145 24.2763 24.5273 20.5635 24.5273 15.9999C24.5273 11.4363 20.8145 7.72363 16.2509 7.72363ZM16.2509 21.0571C13.4579 21.0571 11.1938 18.793 11.1938 16C11.1938 13.207 13.458 10.9428 16.2509 10.9428C19.044 10.9428 21.3081 13.207 21.3081 16C21.3081 18.7929 19.0439 21.0571 16.2509 21.0571Z"
          fill="url(#paint1_linear_9796_197)"
        />
        <path
          d="M24.5417 9.76898C25.637 9.76898 26.5248 8.88111 26.5248 7.78586C26.5248 6.69061 25.637 5.80273 24.5417 5.80273C23.4465 5.80273 22.5586 6.69061 22.5586 7.78586C22.5586 8.88111 23.4465 9.76898 24.5417 9.76898Z"
          fill="url(#paint2_linear_9796_197)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_9796_197"
          x1="16.25"
          y1="31.9068"
          x2="16.25"
          y2="0.248538"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E09B3D" />
          <stop offset="0.3" stopColor="#C74C4D" />
          <stop offset="0.6" stopColor="#C21975" />
          <stop offset="1" stopColor="#7024C4" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_9796_197"
          x1="16.2509"
          y1="31.9067"
          x2="16.2509"
          y2="0.248511"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E09B3D" />
          <stop offset="0.3" stopColor="#C74C4D" />
          <stop offset="0.6" stopColor="#C21975" />
          <stop offset="1" stopColor="#7024C4" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_9796_197"
          x1="24.5417"
          y1="31.9067"
          x2="24.5417"
          y2="0.248482"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E09B3D" />
          <stop offset="0.3" stopColor="#C74C4D" />
          <stop offset="0.6" stopColor="#C21975" />
          <stop offset="1" stopColor="#7024C4" />
        </linearGradient>
        <clipPath id="clip0_9796_197">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0.25)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

InstagramColored.displayName = "InstagramColored";
